<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-form-group
          id="grp_txt_location_code"
          label="Location Code:"
          label-for="txt_location_code"
          label-size="sm"
        >
          <b-form-input
            id="txt_location_code"
            type="text"
            required
            placeholder
            v-model="location_obj.location_code"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="grp_txt_location_priority"
          label="Location Priority:"
          label-for="txt_location_priority"
          label-size="sm"
        >
          <b-form-input
            id="txt_location_priority"
            type="number"
            required
            placeholder
            v-model="location_obj.location_priority"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="grp_txt_remark"
          label="Remark:"
          label-for="txt_remark"
          label-size="sm"
        >
          <b-form-input
            id="txt_remark"
            type="text"
            required
            placeholder
            v-model="location_obj.remark"
          ></b-form-input>
        </b-form-group>

        <b-button
          class="float-right"
          type="submit"
          variant="primary"
          @click="addLocation()"
          >Submit</b-button
        >
      </b-card>

    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "carried_by",
    label: "Carried by"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  }
];

export default {
  name: "TrackingEdit",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      confirm_attention_obj:{},
      status_options: [
        {
          value: null,
          text: "---"
        },
        {
          value: "Rescheduled",
          text: "Rescheduled"
        },
        {
          value: "Cancelled",
          text: "Cancelled"
        },
        {
          value: "Hold",
          text: "Hold"
        },
        {
          value : "null",
          text : "Others",
        }
      ],
      breadcrumb_items: [
        {
          text: "Location Master",
          to: { name: "wms_locations" }
        },
        {
          text: "Form",
          active: true
        }
      ],
      location_obj: {
        location_code: "",
        location_priority: "",
        remark: ""
      },
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pod_image",
          label: "POD"
        },
        {
          key: "updated_by",
          label: "Updated by"
        }
      ],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      user_id: false
    };
  },
  async created() {
    if (this.$route.params.wms_location_id) {
      await this.getLocation();
    }
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
    this.loader.hide();
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getLocation() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_location_get.php",
        data: {
          location_id: this.$route.params.wms_location_id,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id,
        }
      });
      this.location_obj = response.data.locations[0];
    },

    async addLocation() {
      if (this.location_obj.location_code.trim() == "") {
        this.alert_error_message = `Location Code is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);

        return;
      }

      if (this.location_obj.location_priority.trim() == "") {
        this.alert_error_message = `Location Priority is required`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);

        return;
      }

      if (this.$route.params.wms_location_id) {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "wms_location_edit.php",
          data: {
            location_id: this.$route.params.wms_location_id,
            location_obj: this.location_obj,
            user_id: this.$store.state.user_obj.user_id,
            client_id: this.$store.state.user_obj.client_id
          }
        });

        if (response.data.status == "success") {
          this.alert_success_message = `Location Edit Successfully.`;
          this.showAlert_success = true;
          setTimeout(() => {
            this.showAlert_success = false;
            this.alert_success_message = "";
          }, 3000);
          this.$router.go(-1);
        } else {
          alert(response.data.error_msg);
        }
      }
      else{
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "wms_location_add.php",
          data: {
            location_obj: this.location_obj,
            user_id: this.$store.state.user_obj.user_id,
            client_id: this.$store.state.user_obj.client_id
          }
        });

        if (response.data.status == "success") {
          this.alert_success_message = `Location Created Successfully.`;
          this.showAlert_success = true;
          setTimeout(() => {
            this.showAlert_success = false;
            this.alert_success_message = "";
          }, 3000);
          this.$router.go(-1);
        } else {
          alert(response.data.error_msg);
        }
      }
      
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/WMS_LocationsAdd.vue